import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard-login',
  templateUrl: './dashboard-login.component.html',
  styleUrls: ['./dashboard-login.component.css']
})
export class DashboardLoginComponent {
  email = '';
  password = '';
  error = '';
  lang: string = '';

  constructor(private router: Router) {
    this.lang = this.router.url.split('/')[1];
  }

  login() {
    if (this.email === 'GenAISuperAdmin' && this.password === 'GenAI@123321') {
      localStorage.setItem('accessTokenE', this.email);
      localStorage.setItem('accessTokenP', this.password);
      this.router.navigate([`/${this.lang}/admin/dashboard`]);
    } else {
      this.error = 'Invalid credentials';
    }
  }
}
